import { render, staticRenderFns } from "./GoogleMapsLabel.vue?vue&type=template&id=5b56e60b&scoped=true&"
import script from "./GoogleMapsLabel.vue?vue&type=script&lang=ts&setup=true&"
export * from "./GoogleMapsLabel.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./GoogleMapsLabel.vue?vue&type=style&index=0&id=5b56e60b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b56e60b",
  null
  
)

export default component.exports